import {
  IWarningModalModel,
  WarningModalModel,
} from "../lib/interfaces/WarnigModal/IWarningModalModel";
import {
  ISortCartResultModel,
  SortCartValidationResult,
} from "./../lib/interfaces/SortCart/ISortCartResultModel";
import { UNAUTHORIZED_COMPANY_ERROR_CODE } from "./constants/errorCodes";
import { formatDateTime } from "./dateFormatUtil";
import { replaceTextTemplate } from "./stringUtil";
import { getTextByConstant } from "./TextConfigUtil";

export const SetCartValidationResult = (
  cartResult: ISortCartResultModel
): SortCartValidationResult => {
  if (cartResult.validationResult === SortCartValidationResult.UnauthorizedCompany) {
    return cartResult.validationResult;
  } else if (cartResult.validationResult === SortCartValidationResult.ShowMessage) {
    if (cartResult.instruction) {
      return SortCartValidationResult.HasInstruction;
    }
  } else if (cartResult.validationResult === SortCartValidationResult.OK) {
    return SortCartValidationResult.OK;
  }
  return SortCartValidationResult.undefined;
};

export const getCartValidationResultWarning = (
  cartResult: ISortCartResultModel
): IWarningModalModel => {
  let message = getTextByConstant(SortCartValidationResult, cartResult.validationResult) || "";

  if (cartResult.validationResult === SortCartValidationResult.UnauthorizedCompany) {
    const replacements = {
      companyName: cartResult.companyName,
      sortID: cartResult.sortID,
      sortCreated: formatDateTime(cartResult.sortCreated),
    };

    message = replaceTextTemplate(message, replacements);
  }

  const errorCode = UNAUTHORIZED_COMPANY_ERROR_CODE;

  const header =
    getTextByConstant(SortCartValidationResult, cartResult.validationResult, "header") || "";

  return new WarningModalModel(message, errorCode, header);
};
